import { Component, OnInit } from '@angular/core';
import { AllwebjobstatusService } from 'src/app/services/allwebjobstatus.service';
import { environment } from '../../../environments/environment';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  standalone: false,
  selector: 'app-allwebjobstatus',
  templateUrl: './allwebjobstatus.component.html',
  styleUrls: ['./allwebjobstatus.component.css']
})
export class AllwebjobstatusComponent implements OnInit {
  private EnvName = environment.ENV;
  data: any;

  constructor(private allwebjobstatusService: AllwebjobstatusService, private route: ActivatedRoute, public router: Router) { }

  ngOnInit() {
    if (this.EnvName === 'Prod') {
      this.router.navigate(['/home']);
    }

    this.allwebjobstatus();
  }

  allwebjobstatus() {
    this.allwebjobstatusService.getAllwebjobstatus().subscribe((resp: any[]) => {
      this.data = resp;
    });
  }
}
